module.exports = __webpack_public_path__ + "img/ic01.4e2416ba.png";